export const SHORTCUT_REPING_AUTH = `
  pingAuth {
    id
    status
    brands {
      id
      slug
    }
  }
`

export const SHORTCUT_PAGE_INFO_FIELDS = `
  page
  perPage
  lastPage
  next
  total
`

export const SHORTCUT_PRODUCT_PRICE_FIELDS = `
  count_multiplier
  min_count
  price
  price_type
  weight
`

export const SHORTCUT_CATALOG_PRODUCT_FIELDS = `
  id
  xid
  article_num
  name
  weight
  weight_netto
  count_multiplier
  min_count
  max_amount
  short_description
  status
  w
  h
  l
  v
  volume
  pkg
  ingredients
  nutval
  brand_id
  shop_ids
  slug
  brand {
    id
    name
  }
  prices {
    shop_id
    price
    unit_multiplier
    salePeriod {
      start
      finish
    }
    currentPrice
    olderPrice
    discount_price
  }
  singlePrice
  useSinglePrice
  stocks {
    shop_id
    amount
  }
  singleStock
  useSingleStock
  price_type
  preview_id
  preview {
    url
  }
  markable
  markCodeType
  excisable

  indexable

  average_rating
  review_count

  is_private_label
  is_own_brand
  is_alcohol
  manufacturer

  priority
`

export const ORDER_FIELDS = `
  id
  shop_id
  zone_id
  customerGeoPoint {
    longitude
    latitude
  }
  totalCashback
  address
  step

  address_appartments
  comment
  address_intercom
  address_porch
  address_floor
  door_delivery
  deliveryType
  slot_id
  customerCourierMessage

  payment_type

  cash_change
  receipt_email
  recipientInfo {
    firstName
    lastName
  }

  paymentOrderFile {
    url
  }
`

export const ORDER_SHOP_FIELDS = `
  shop {
    id
    name
    address
    minOrderCost
    shopGeoPoint {
      longitude
      latitude
    }
  }
`

export const ORDER_PRODUCTS_FIELDS = `
  # imitate: orderPosition -> cartItem
  cartCompatibleCustomerProducts: customerProducts {
    id: product_id
    amount: count
    total
    shop_id
  }
`

export const ORDER_PRODUCTS_ALL_FIELDS = `
  customerProducts {
    id
    name
    count
    price
    total
    shop_id
    assembled_price
    assembled_total
    assembled_count
    status
    cashback
    product {
      id
      xid
      article_num
      name
      price_type
      min_count
      count_multiplier
      preview {
        url
      }
    }
  }
`

export const ORDER_TOTALS_FIELDS = `
  totalCost
  saledCost
  total
  delivery_total
  assembledOrderTotal
`

/*
  Product gql shortcuts
*/

export const PRODUCT_FIELDS = `
  id
  xid
  name
`

export const PRODUCT_WEIGHT_FIELDS = `
  weight
  weight_multiplier
`

export const PRODUCT_PRICE_FIELDS = `
  price
  oldPrice
  price_type
  min_count
`

export const PRODUCT_SALE_FIELDS = `
  salePeriod {
    finish
  }
`
export const PRODUCT_STOCK_FIELDS = `
  stock {
    amount
  }
`

export const PRODUCT_PREVIEW_FIELDS = `
  preview {
    url
  }
`

export const PRODUCT_ADDITIONAL_INFO = `
  w
  h
  l
`

export const PRODUCT_FULL_INFO = `
  ${PRODUCT_FIELDS}
  ${PRODUCT_PRICE_FIELDS}
  ${PRODUCT_PREVIEW_FIELDS}
  ${PRODUCT_SALE_FIELDS}
  ${PRODUCT_WEIGHT_FIELDS}
`

export const PRODUCT_SEARCH_INFO = `
  ${PRODUCT_FIELDS}
  ${PRODUCT_STOCK_FIELDS}
  ${SHORTCUT_PRODUCT_PRICE_FIELDS}
`

export const SHORTCUT_CART_PRODUCT_FIELDS = `
  ${PRODUCT_FIELDS}
  ${PRODUCT_STOCK_FIELDS}
  ${SHORTCUT_PRODUCT_PRICE_FIELDS}
`

export const PRODUCT_REVIEW_FIELDS = `
  id
  status
  customer_id
  product_id
  rating
  comment
`

export const SHORTCUT_PROMOCODE_FIELDS = `
  id
  code
  is_active
  active_from
  active_until
  activated_count
  max_total_activation_count
  delivery_discount
  delivery_discount_in_percent
  cart_total_discount
  discount_in_percents
  max_order_discount
  max_order_discount_in_percent
  for_first_delivery_only
  min_order_total
  max_customer_activation_count
`

export const SHORTCUT_LOYALTY_COUPON_SERIES_FIELDS = `
  id
  code
  title
  description
  image_file_id
  ts_valid_from
  ts_valid_until
  created_at
  updated_at
  isActive
  validFrom
  validUntil
  image {
    url
  }
  i18n {
    id
    language_code
    title
    description
  }

  canBeActivated
`

export const SHORTCUT_EMPLOYEE_FIELDS = `
  id
  first_name
  last_name
  status
  phone
  fullName
`

export const SHORTCUT_CUSTOMERS_FIELDS = `
  id
  phone
  created_at
  updated_at
  fullName
  first_name
  last_name
  receipt_email
  customerEmail
  status
  usedPromocodes {
    id
    usedAt
    code
    type
  }
  paymentTokens {
    id
    created_at
    info {
      type
      card
      last
      country
    }
  }
`

export const SHORTCUT_BANNERS_FIELDS = `
  id
  file_id
  mobile_file_id
  name
  url
  status
  bannerSlide(style:"1200xauto") {
    url
  }
  bannerMobileSlide(style:"1200xauto") {
    url
  }
  bannerType {
    id
    label
    code
  }
  optionOpenInNewWindow
  optionOpenInBrowser
  activeFrom
  activeUntil
`

export const SHORTCUT_BANNER_TYPE_FIELDS = `
  id
  label
  code
`

export const SHORTCUT_STORIES_FIELDS = `
  id
  preview_id
  name
  status
  sort_order
  preview {
    url
  }
  created_at
  updated_at
  slides {
    id
    name
    status
    image_id
    url
    sort_order
    image {
      url
    }
    optionOpenInBrowser
    optionOpenInNewWindow
  }
  activeFrom
  activeUntil
`

export const SHORTCUT_LABELS_FIELDS = `
  id
  system_name
  name
  description
  status
  sort_order
  image {
    url
  }
  activeFrom
  activeUntil
  optionColor
  optionBackgroundColor
  optionLink
  optionLinkLabel
`

export const SHORTCUT_BUSINESS_PROFILES_FIELDS = `
  id
  created_at
  updated_at
  xid
  name
  type
  status
  tin
  address
  phone_number
  director
  signAuthorizedPerson
  deferredInfo {
    deferred_payment_status
    deferred_payment_days
    deferred_payment_amount_limit
    deferred_payment_available_limit
  }
  require_invoice
  bankDetails {
    accountNumber
    bankName
    bik
  }
  vat_enabled
  registrationScan {
    url
  }
  directorConfirmScan {
    url
  }
  attorneyScan {
    url
  }
  monthlyRevenue
  accountRP
  
`

export const SHORTCUT_BUSINESS_PROFILE_OWNER_FIELDS = `
  owner {
    id
    phone
    first_name
    last_name
  }
`

export const SHORTCUT_BUSINESS_PROFILE_MANAGERS_FIELDS = `
  accounts {
    id
    manager_status
    role
    phone
    first_name
    last_name
  }
`

export const SHORTCUT_BUSINESS_PROFILES_ORDERS_FIELD = `
  orders {
    id
  }
`

export const SHORTCUT_DELIVERY_CLAIM_FEILDS = `
  id
  xid
  status
  pickupAddress
  pickupGeoPoint {
    geo_lat
    geo_lon
    latitude
    longitude
  }
  targetAddress
  targetGeoPoint {
    geo_lat
    geo_lon
    latitude
    longitude
  }
  packageWeight
  packageWidth
  packageHeight
  packageLength
  deliveryProvider
  wasStarted
  needAccept
  canAccept
  issueCode
  performerTransport
  performerTransportColor
  performerTransportColorHEX
  performerTransportNumber
  performerTransportModel
  deadlineAt
  updated_at
`

export const SHORTCUT_ORDER_RECEIPT_FIELDS = `
  id
  type
  status
  total
  device_code
  order {
    id
  }
  receipt_created_at
  fn_number
  fiscal_document_number
  fiscal_document_attribute
  external_id
  shift_number
  ecr_registration_number
  receiptQueryString
  ofd_receipt_url
`

export const SHORTCUT_DELIVERY_ZONE_FIELDS = `
  id
  name
  status
  shop_id
  minOrderCost
  customer_order
  zoneSlotMaxWeight
  zoneDeliveryCost
  zoneFirstDeliveryCost
  freeSlotDeliveryCostFrom

  zoneGeoDeliveryZone {
    latitude
    longitude
  }

  zoneExpressMaxWeight
  zoneTsExpressDeliveryStart
  zoneTsExpressDeliveryFinish
  zoneExpressDeliveryCost
  zoneHasExpressDeliveryEnabled
  expressDeliveryMaxShippingTime
  freeExpressDeliveryCostFrom
  useFirstDeliveryPrice

  tzOffset

  deliveryProviders


  slotPlans {
    id
    shop_id
    weekDay
    slotStartTime
    slotFinishTime
    ordersLimit
    positionsLimit
    slotTimeout
  }

  is_serving_wholesale
  is_serving_retail


  slotProvider
  slotConfig {
      max_orders_limit
      max_order_positions_limit
      slot_timeout_value
      generateFrom
      generateTo
  }
  slotDeliveryPriceProvider
  expressDeliveryPriceProvider
  expressDeliveryTimeout
  startDeliveryOnPlaceOrder
  slotPriceMultuplier
  slotPriceAdditional
  expressPriceMultuplier
  expressPriceAdditional
`

export const SHORTCUT_PRODUCT_GROUP_FIELDS = `
  id
  created_at
  updated_at
  name
  label
  type
  brand_id
  customer_id
  i18n {
    language_code
    label
  }
`

export const SHORTCUT_PRODUCT_ATTRIBUTE_FIELDS = `
  id
  created_at
  updated_at
  name
  slug
  is_system
  prefix
  postfix
  is_searchable
  xname
  is_filterable
  filter_name
  value_type
`

export const SHORTCUT_MAIN_PAGE_CONFIG_FIELDS = `
  id
  created_at
  updated_at
  name
  type
  is_active
  isDefault
  activeFrom
  activeUntil
  blocks {
    id
    type
    subtype
    order
    payload
  }
`